import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card rounded-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex align-items-center mb-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "mb-1 text-subtitle" }
const _hoisted_6 = { class: "text-label mb-0" }
const _hoisted_7 = { class: "ms-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash-alt" }, null, -1)
const _hoisted_9 = { class: "text-paragraph text-wrap" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "text-paragraph mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "text-subtitle" }
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2 text-secondary",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchInput = _resolveComponent("SwitchInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.rating.formatted_profile_image,
          alt: "",
          height: "40",
          width: "40",
          class: "rounded-circle me-2"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.rating.user.name.split(" ")[0]), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.rating.formatted_date), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", {
            class: "text-subtitle text-danger cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRemove(_ctx.rating.id)))
          }, [
            _createTextVNode(" Reportar "),
            _hoisted_8
          ])
        ])
      ]),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.rating.testimonial), 1),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, [
          _createTextVNode(" Este depoimento está"),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.rating.active ? "aparecendo" : "oculto"), 1),
          _createTextVNode(" no seu perfil ")
        ]),
        (_ctx.rating.submitting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15))
          : (_openBlock(), _createBlock(_component_SwitchInput, {
              key: 1,
              id: `rating_${_ctx.rating.id}`,
              checked: _ctx.rating.active,
              color: "secondary",
              onHandleChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange(_ctx.rating)))
            }, null, 8, ["id", "checked"]))
      ])
    ])
  ]))
}